module.exports = __webpack_public_path__ + "img/mail_white.77f59348.svg";